import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

export const BookingIdResolver: ResolveFn<{ id: string }> = (
  route: ActivatedRouteSnapshot
): { id: string } => {
  const bookingId = encodeURIComponent(route.paramMap.get('id'));

  return { id: bookingId || '' };
};
